export var BASE_URL = "http://horoscope.numobi.net";
export var SECRET_KEY = "9Wt1DiuDqxiwgMws";
export var UA = "horoscope/1.0.1 (iPad; iOS 12.1; Scale/2.00)";
export var FACE_PRE_CHECK_PATH = "/facesecret/check";
export var FACE_AGE_PATH = "/facesecret/age";
export var FACE_ETHNICITY_PATH = "/facesecret/ethnicity";
export var FACE_BABY_PATH = "/facesecret/baby";
export var FACE_FUTURE_PATH = "/facesecret/future";
export var FACE_BEAUTY_PATH = "/facesecret/beauty";